import React, { createContext, useContext, useState } from "react";
import en, { Dict } from "@/locales/en";
import hi from "@/locales/hi";

// Add kn/te by dropping a new locale file into this map.
const LOCALES: Record<string, Partial<Dict>> = { en, hi };
export type Lang = "en" | "hi";
export type TKey = keyof Dict;

type Ctx = { lang: Lang; setLang: (l: Lang) => void; t: (k: TKey) => string; alt: (k: TKey) => string };
const I18nCtx = createContext<Ctx>(null as any);

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>((localStorage.getItem("pg_lang") as Lang) || "en");
  const setLang = (l: Lang) => {
    localStorage.setItem("pg_lang", l);
    document.documentElement.lang = l;
    setLangState(l);
  };
  const pick = (l: string, k: TKey) => (LOCALES[l]?.[k] as string) ?? en[k] ?? k;
  const t = (k: TKey) => pick(lang, k);
  const alt = (k: TKey) => pick(lang === "en" ? "hi" : "en", k);
  return <I18nCtx.Provider value={{ lang, setLang, t, alt }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);

export const LANGUAGES: { value: Lang; label: string }[] = [
  { value: "en", label: "English" },
  { value: "hi", label: "हिंदी (Hindi)" },
];

/** Label in the owner's chosen language. */
export function Bi({ k, className = "" }: { k: TKey; className?: string; subClassName?: string }) {
  const { t } = useT();
  return <span className={className}>{t(k)}</span>;
}
